import { Blockquote, Inset, Link, Text } from "@radix-ui/themes";
import AddBottomSpace from "../../components/AddBottomSpace";
import AddHeadline from "../../components/AddHeadline";
import AddTopSpace from "../../components/AddTopSpace";

export default function EventsPast() {

  return (
    <>
      <AddTopSpace />
      <AddHeadline />
      <div className="container">

        <div className='row'>

          <div className='col-lg-4'>
            <div className="container py-3">
              <div className='row pb-1'>
                <div className='col'>
                  
                </div>
              </div>
            </div>
          </div>
          
          <div className='col-lg-8'>
            <div className="container py-3">
              <div className='row pb-3'>
                <div className='col'>
                  <Blockquote size="6" color>
                    Past Events
                  </Blockquote>
                </div>
              </div>
            </div>
          </div>

        </div>

        <div className='row'>
          
          <div className='col-lg-4'>
            <div className="container py-3">

              <div className='row pb-1'>
                <div className='col'>
                  <Blockquote size="6" color>
                    Alain Daniélou Foundation
                  </Blockquote>
                </div>
              </div>

              <div className='row py-3'>
                <div className='col'>
                  <Inset clip="padding-box" side="top" pb="current">
                    <img
                      src="https://www.shadvala.org/img/interstices-logo-ad.jpg"
                      alt="Alain Daniélou Foundation"
                      style={{
                        display: 'block',
                        objectFit: 'cover',
                        width: '40%',
                        height: '40%',
                        backgroundColor: 'var(--gray-5)',
                      }}
                    />
                  </Inset>
                </div>
              </div>
            </div>
          </div>
          
          <div className='col-lg-8'>
            <div className="container py-3">
              <div className='row pb-3'>
                <div className='col'>
                  <Text as="p" mb="5" size="6">
                    The Labyrinth as Inspiration 
                  </Text>
                </div>
              </div>
              <div className='row pb-3'>
                <div className='col'>
                  <Text as="p" mb="5" size="4">
                  An undeniable inspiration for our transcultural and ecosophical platform has been Alain Daniélou’s labyrinth. In the context of his work, the labyrinth is at the same time a concrete place at Zagarolo (Roman Province) where Daniélou spent the last decades of his life, the main fictional locus in his second collection of tales published shortly before his death, a topological metaphor of the universe seen from different cosmologies, and a figure that epitomizes his permanent re-orientation of ideas to broaden already established exploration fields.
                  </Text>
                </div>
              </div>
              <div className='row pb-3'>
                <div className='col'>
                  <Text as="p" mb="5" size="4">
                    In the Greek myth of the Labyrinth, the Minotaur represents the radical ‘Other’ who must be conquered by the civilizational power of Theseus. The figure of the labyrinth at the cradle of Western thought is therefore disquieting and even threatening, and its reception has mainly emphasized the disorientation one could suffer along the way from the entrance to the center – and back again. Daniélou inverses the picture and focuses on the trajectory and the manifold paths, which renders both the center and the exit inconsequential – since the center is everywhere and the labyrinth knows no external limit.
                  </Text>
                </div>
              </div>
              <div className='row pb-3'>
                <div className='col'>
                  <Text as="p" mb="5" size="4">
                    Daniélou’s attitude toward the labyrinth is a remarkable way of expressing a perspectivist approach to knowledge (against both religious fanaticism and positivist reductionism), and a declaration of faith in the significance (i. e. the enriching power) of indirect, winding or twisted paths as well as in the traces left by former explorers of the labyrinth. It could be summarized as an imperative to learn from the Other instead of trying to conquer it.
                  </Text>
                </div>
              </div>

            </div>
          </div>

        </div>


        <div className='row'>
          
          <div className='col-lg-4'>
            <div className="container py-3">
              <div className='row pb-1'>
                <div className='col'>
                  <Blockquote size="6" color>
                    Past Interactions
                  </Blockquote>
                </div>
              </div>
            </div>
          </div>
          
          <div className='col-lg-8'>
            <div className="container py-3">
              <div className='row pb-3'>
                <div className='col'>
                  <Text as="p" mb="5" size="4">
                    Direct link to <Link href="https://www.fondationalaindanielou.org/intellectual-dialogue/intellectual-dialogue-events/" target="_blank">
                    “FAD Interactions” 
                      <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3 2C2.44772 2 2 2.44772 2 3V12C2 12.5523 2.44772 13 3 13H12C12.5523 13 13 12.5523 13 12V8.5C13 8.22386 12.7761 8 12.5 8C12.2239 8 12 8.22386 12 8.5V12H3V3L6.5 3C6.77614 3 7 2.77614 7 2.5C7 2.22386 6.77614 2 6.5 2H3ZM12.8536 2.14645C12.9015 2.19439 12.9377 2.24964 12.9621 2.30861C12.9861 2.36669 12.9996 2.4303 13 2.497L13 2.5V2.50049V5.5C13 5.77614 12.7761 6 12.5 6C12.2239 6 12 5.77614 12 5.5V3.70711L6.85355 8.85355C6.65829 9.04882 6.34171 9.04882 6.14645 8.85355C5.95118 8.65829 5.95118 8.34171 6.14645 8.14645L11.2929 3H9.5C9.22386 3 9 2.77614 9 2.5C9 2.22386 9.22386 2 9.5 2H12.4999H12.5C12.5678 2 12.6324 2.01349 12.6914 2.03794C12.7504 2.06234 12.8056 2.09851 12.8536 2.14645Z" fill="currentColor" fill-rule="evenodd" clip-rule="evenodd"></path></svg>
                    </Link>
                  </Text>
                </div>
              </div>
            </div>
          </div>

        </div>



      </div>
      
      <AddBottomSpace />
    </>
  )
}
